import React from "react";

export const en = {
  body: (
    <div>
      <h3>The bibliographic database of vegetation of the Czech Republic</h3>
      The bibliographic database of vegetation of the Czech Republic (
      <a href="https://www.sci.muni.cz/botany/tvref/">https://www.sci.muni.cz/botany/tvref/</a>) was
      created in connection with the development of the Czech Vegetation Database
      and the project Vegetation of the Czech Republic. The database contains publications
      containing phytosociological relevés from the Czech Republic or syntaxonomic notes on Czech
      vegetation.
    </div>
  )
};

export const cz = {
  body: (
    <div>
      <h3>Bibliografická databáze vegetace České republiky</h3>
      Bibliografická databáze vegetace České republiky (
      <a href="https://www.sci.muni.cz/botany/tvref/">https://www.sci.muni.cz/botany/tvref/</a>)
      byla vytvořena v souvislosti s přípravou České vegetační databáze a projektem
      Vegetace České republiky. Databáze obsahuje publikace, ve kterých jsou fytocenologické snímky z
      území České republiky nebo syntaxonomické poznámky k české vegetaci.
    </div>
  )
};
